export enum ErrorConstants {
    BFFDownError = "BFFDownError",
    DealerLookUpError = "DealerLookUpError",
}
